export { default } from './ExpansionPanelDetails';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/ExpansionPanelDetails/index.js
// module id = 795
// module chunks = 121